import logo from './logo.svg';
import { Provider } from './context.js';
import { RoutesMain } from './components/RoutesMain';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import ant_theme from './ant_theme.json';
import './misha.css';
import './add.css';


function App() {
  return (
    <div className="" style={{
      backgroundColor: '#000000',
      width: '100%',
      // overflowX: 'hidden',
      position: 'relative'
    }}>
      <HelmetProvider>
        <Provider>
          <ConfigProvider
            theme={ant_theme}
          >
            <RoutesMain />
          </ConfigProvider>
        </Provider>
      </HelmetProvider>
    </div>
  );
}

export default App;
